'use client';

/**
 * connect0 skill §Q.9 — per-route error boundary (spec 107 phase D).
 */
import { RouteError } from '@/components/route-error';

export default function RouteErrorBoundary(props: { error: Error & { digest?: string }; reset: () => void }) {
  return <RouteError {...props} label="MCP server directory" />;
}
